/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LocationQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("LocationQueryOperator");
    }

    getFixupPrototypeFunction() { return LocationQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<LocationQueryOperator>): LocationQueryOperator {
        let obj = Object.assign(new LocationQueryOperator(), model);
        LocationQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LocationQueryOperator>): LocationQueryOperator {
        if (!model) return null;
        return LocationQueryOperator.newInstance(<LocationQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LocationQueryOperator) {
        if (!obj) return;

        models.LocationQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LocationQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LocationQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Locations to include
     */
    locations: Array<string>;

}
